import { round, truncate } from 'lodash'
import { Group, Avatar, Text } from '@mantine/core'
import Note from '../../../components/Note'
import { reviewNotes } from '../../../utils/review'
import { Brand } from '../../../types'
import type { ColumnType } from '../../../components/AdminDataTable'
import { Car } from 'lucide-react'

const BrandLogo = ({ brand }: { brand: Brand }) => (
    <img
      src={brand.logo}
      alt={brand.title}
      style={{ width: 32, height: 32, objectFit: 'contain', borderRadius: 4 }}
    />
)

export const columns: ColumnType<Brand>[] = [
  {
    accessor: 'title',
    title: 'Marque',
    render: (brand) => (
      <Group gap="sm">
        <BrandLogo brand={brand} />
        <Text size="sm" fw={500}>{brand.title}</Text>
      </Group>
    ),
  },
  {
    
    accessor: 'reviews_count',
    title: "Nombre d'avis",
    textAlign: 'center',
    width: 120,
    render: (brand) => {
      if (!brand.reviews_count) return <Text size="sm" c="dimmed">—</Text>
      return <Text size="sm">{brand.reviews_count.toLocaleString()}</Text>
    },
  },
  {
    accessor: 'note',
    title: 'Note moyenne',
    textAlign: 'center',
    sortable: true,
    width: 120,
    render: (brand) => {
      const value = round(brand.note ?? 0, 2)
      return <Note note={value} size="small" />
    },
  },
  ...(reviewNotes.map((note) => ({
    accessor: note.name,
    title: truncate(note.label, { length: 15 }),
    textAlign: 'center' as const,
    sortable: true,
    width: 120,
    render: (brand: Brand) => {
      const value = round(brand?.notes?.[note.name as keyof typeof brand.notes] ?? 0, 1)
      return <Note note={value} size="small" />
    },
  }))),
]
